(() => {
  const storageKey = 'liva7-color-mode';
  const root = document.documentElement;
  const toggle = document.querySelector('[data-l7-theme-toggle]');
  const themeMeta = document.querySelector('meta[name="theme-color"]');
  const systemPreference = window.matchMedia('(prefers-color-scheme: dark)');

  const savedMode = () => {
    try {
      return localStorage.getItem(storageKey);
    } catch (error) {
      return null;
    }
  };

  const swapLogos = (mode) => {
    document.querySelectorAll('[class^="ai-header-logo-"] img').forEach((logo) => {
      if (!logo.dataset.l7LightLogo && logo.src.includes('liva7-logo-ink.svg')) {
        logo.dataset.l7LightLogo = logo.src;
        logo.dataset.l7DarkLogo = logo.src.replace('liva7-logo-ink.svg', 'liva7-logo.svg');
      }
      const source = mode === 'dark' ? logo.dataset.l7DarkLogo : logo.dataset.l7LightLogo;
      if (source && logo.src !== source) logo.src = source;
    });
  };

  const applyMode = (mode, persist = false) => {
    const nextMode = mode === 'dark' ? 'dark' : 'light';
    root.dataset.l7Theme = nextMode;
    root.style.colorScheme = nextMode;

    if (persist) {
      try {
        localStorage.setItem(storageKey, nextMode);
      } catch (error) {
        // The selected mode still applies for the current page.
      }
    }

    if (toggle) {
      const nextLabel = nextMode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode';
      toggle.setAttribute('aria-label', nextLabel);
      toggle.setAttribute('aria-pressed', String(nextMode === 'dark'));
      const label = toggle.querySelector('[data-l7-theme-label]');
      if (label) label.textContent = nextLabel;
    }

    if (themeMeta) themeMeta.setAttribute('content', nextMode === 'dark' ? '#0b0d12' : '#ffffff');
    swapLogos(nextMode);
  };

  applyMode(root.dataset.l7Theme || (systemPreference.matches ? 'dark' : 'light'));

  toggle?.addEventListener('click', () => {
    applyMode(root.dataset.l7Theme === 'dark' ? 'light' : 'dark', true);
  });

  systemPreference.addEventListener?.('change', (event) => {
    if (!savedMode()) applyMode(event.matches ? 'dark' : 'light');
  });

  document.addEventListener('shopify:section:load', () => swapLogos(root.dataset.l7Theme));
})();
